import { Component, inject } from '@angular/core';

import { environment } from '../../../../environments/environment';

import { LoadingScreenService } from './loading-screen.service';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss'],
  standalone: false
})
export class LoadingScreenComponent {
  loadingScreenService = inject(LoadingScreenService);

  erpLogoUrl = environment.erpLogoUrl + '?t=' + Date.now();
}
